import QRCode from "qrcode";
import { useEffect, useRef } from "react";

const PrintQCShipment = ({ formId, groupId, items, onDone, submittedDate, formNumber = "F-QP-QC-01-01" }) => {
  const hasPrinted = useRef(false);

  useEffect(() => {
    if (hasPrinted.current) return;
    hasPrinted.current = true;

    const canvas = document.createElement("canvas");
    QRCode.toCanvas(canvas, groupId, { width: 100 }, (error) => {
      if (error) console.error(error);
      const dataUrl = canvas.toDataURL("image/png");

      const fmtQty = (n) => Number(n).toLocaleString("en-US");

      const itemRows = items
        .map(
          (item, index) => `
          <tr>
            <td style="text-align:center;"><input type="checkbox" /></td>
            <td style="text-align:center;">${index + 1}</td>
            <td style="font-family:monospace;">${item.product_code || ""}</td>
            <td>${item.product_name || ""}</td>
            <td style="text-align:right; font-weight:bold;">${fmtQty(item.ship_qty)}</td>
            <td>${item.remark || ""}</td>
            <td>${item.customer || ""}</td>
          </tr>`,
        )
        .join("");

      const submittedDate_str = submittedDate
        ? new Date(submittedDate).toLocaleString()
        : new Date().toLocaleString();
      const submittedBy = items[0]?.username || "N/A";

      const formBlock = `
        <div class="form-block">
          <div class="page-header">
            <h1>QC TRANSFER TO STORE</h1>
            <h2>Form Number: <strong>${formId}</strong></h2>
          </div>

          <div class="meta-row">
            <div class="meta-left">
              <span><strong>Transaction ID:</strong> ${groupId}</span>
              <span><strong>Date:</strong> ${submittedDate_str}</span>
              <span><strong>Submitted By:</strong> ${submittedBy}</span>
            </div>
            <div class="qr-block">
              <img src="${dataUrl}" alt="QR Code" />
              <small>Scan to approve</small>
            </div>
          </div>

          <table>
            <colgroup>
              <col /><col /><col /><col /><col /><col /><col />
            </colgroup>
            <thead>
              <tr>
                <th>✓</th>
                <th>No</th>
                <th>Product Code</th>
                <th>Product Name</th>
                <th>Qty</th>
                <th>Remark / Catatan</th>
                <th>Customer / For</th>
              </tr>
            </thead>
            <tbody>${itemRows}</tbody>
          </table>

          <div class="signature-row">
            <div class="signature-block">
              <p><strong>Prepared By (QC): ${submittedBy}</strong></p>
              <div class="signature-line"></div>
              <p>Name &amp; Signature</p>
            </div>
            <div class="signature-block">
              <p><strong>Received By (Store)</strong></p>
              <div class="signature-line"></div>
              <p>Name &amp; Signature</p>
            </div>
            <div class="signature-block">
              <p><strong>Approved By</strong></p>
              <div class="signature-line"></div>
              <p>Name &amp; Signature</p>
            </div>
          </div>

          <div class="footer">
            <span>Form: ${formNumber}</span>
          </div>
        </div>
      `;

      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
          <head>
            <title>QC Shipment Form</title>
            <style>
              @page { size: 148mm 210mm; margin: 0; }
              * { box-sizing: border-box; }
              body { font-family: Arial, sans-serif; font-size: 13px; margin: 0; padding: 10mm 10mm 8mm 10mm; }

              .form-block {
                width: 100%;
                padding: 0;
              }

              .page-header { text-align: center; margin-bottom: 6px; }
              .page-header h1 { font-size: 18px; margin: 0 0 2px 0; letter-spacing: 2px; }
              .page-header h2 { font-size: 13px; margin: 2px 0; font-weight: normal; }

              .meta-row {
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                margin: 5px 0;
                padding: 6px 10px;
                border: 1px solid #ccc;
                border-radius: 4px;
                background: #f9f9f9;
              }
              .meta-left { line-height: 1.8; }
              .meta-left span { display: block; font-size: 12px; }
              .meta-left strong { font-size: 12px; }
              .qr-block { text-align: center; }
              .qr-block img { width: 70px; height: 70px; display: block; }
              .qr-block small { font-size: 11px; color: #666; }

              table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
                margin-top: 6px;
              }
              colgroup col:nth-child(1) { width: 4%; }
              colgroup col:nth-child(2) { width: 5%; }
              colgroup col:nth-child(3) { width: 15%; }
              colgroup col:nth-child(4) { width: 30%; }
              colgroup col:nth-child(5) { width: 12%; }
              colgroup col:nth-child(6) { width: 18%; }
              colgroup col:nth-child(7) { width: 16%; }

              th, td {
                border: 1px solid #bbb;
                padding: 5px 6px;
                font-size: 12px;
                word-wrap: break-word;
                overflow-wrap: break-word;
              }
              th {
                background-color: #e0e0e0;
                font-weight: bold;
                text-align: center;
                font-size: 11px;
                text-transform: uppercase;
                letter-spacing: 0.5px;
              }
              tbody tr:nth-child(even) { background-color: #f5f5f5; }

              .signature-row {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
              }
              .signature-block {
                width: 30%;
                text-align: center;
                font-size: 12px;
              }
              .signature-block p { margin: 2px 0; }
              .signature-line {
                border-bottom: 1px solid #000;
                height: 55px;
                margin: 4px 0 2px 0;
              }

              .footer {
                margin-top: 6px;
                text-align: right;
                font-size: 11px;
                color: #666;
              }

              .no-print { margin: 20px auto; text-align: center; }
              button {
                font-size: 15px;
                padding: 8px 20px;
                background-color: #007bff;
                color: white;
                border: none;
                border-radius: 6px;
                cursor: pointer;
              }
              @media print { .no-print { display: none; } }
            </style>
          </head>
          <body>
            ${formBlock}

            <div class="no-print">
              <button onclick="window.print()">🖨️ Print This Page</button>
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
      if (onDone) setTimeout(() => onDone(), 500);
    });
  }, [groupId, items, onDone, submittedDate, formNumber]);

  return null;
};

export default PrintQCShipment;
